import { useTranslation } from 'react-i18next'
import { useProfile } from '@/hooks/useProfile'
import { useSubscription, FEATURE_GATES } from '@/hooks/useSubscription'
import { QRCodeGenerator } from '@/components/dashboard/QRCodeGenerator'
import { useDashboardEmbedded } from '@/hooks/useDashboardEmbedded'

export default function QRCodeSettings() {
  const { t } = useTranslation('dashboard')
  const embedded = useDashboardEmbedded()
  const { profile, isLoading } = useProfile()
  const { hasFeature } = useSubscription()

  if (isLoading) {
    return <div>{t('qrcode.loading')}</div>
  }

  if (!profile) {
    return <div>{t('qrcode.loading')}</div>
  }

  const profileUrl = `${window.location.origin}/${profile.slug}`
  const canUseBranding = hasFeature(FEATURE_GATES.QR_CODE_BRANDED)

  return (
    <div className="p-6 lg:p-8 max-w-2xl">
      {!embedded && (
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">{t('qrcode.title')}</h1>
          <p className="text-gray-500">{t('qrcode.subtitle')}</p>
        </div>
      )}

      <QRCodeGenerator
        profileUrl={profileUrl}
        businessName={profile.business_name}
        allowBranding={canUseBranding}
      />
    </div>
  )
}
